import { getStorageItem, removeStorageItem, setStorageItem } from "./storage";

/**
 * Guarda a última região de onde o jogador saiu para ver um conteúdo externo
 * (artigo, quiz, curso...).
 *
 * Ao voltar, o widget pergunta a região para a página que o hospeda
 * (mensagem `get-origin`). Quando ninguém responde — caso do navegador in-app
 * do aplicativo mobile —, essa marca é usada para reabrir o jogo na região
 * certa em vez da home.
 */

const STORAGE_KEY = "@TeenSmart:lastRegion";

/** Depois desse tempo, presumimos que é uma nova sessão e a home é o esperado. */
export const LAST_REGION_MAX_AGE = 30 * 60 * 1000;

type StoredRegion = {
  region: string;
  time: number;
};

export function rememberLastRegion(region?: string) {
  if (!region) return;

  try {
    setStorageItem(STORAGE_KEY, { region, time: Date.now() }, true);
  } catch (error) {
    // Navegação privada ou storage bloqueado: seguimos sem a marca.
    console.warn("Não foi possível guardar a última região", error);
  }
}

export function getRecentRegion(maxAge = LAST_REGION_MAX_AGE): string | null {
  const stored = getStorageItem(STORAGE_KEY, true) as StoredRegion | null;

  if (!stored?.region || !stored?.time) return null;

  if (Date.now() - stored.time > maxAge) {
    forgetLastRegion();
    return null;
  }

  return stored.region;
}

export function forgetLastRegion() {
  removeStorageItem(STORAGE_KEY, true);
}
